import { css, jsx } from '@emotion/react';
import InAppTopbar from './UniversalTopbar/InAppTopbar/InAppTopbar';
import { addParamsToUrl, extractParams } from '@zapier/url-utils';
import { useUniversalNavContext, useQuerySession } from '../hooks';
import findAccountsMenuRenderer from '../utils/findAccountsMenuRenderer';
import findNotificationsRenderer from '../utils/findNotificationsRenderer';
import { loginPath, signupPath, skipLinkHref as skipLinkHrefDefault, UNIVERSAL_TOPBAR_HEIGHT, } from '../constants';
import InAppSidebar from './UniversalSidebar/InAppSidebar/InAppSidebar';
import { boxSizing } from '../../utils/style-mixins/reset';
const Styles = {
    root: css(Object.assign({}, boxSizing)),
    legacySidebar: css({
        left: 0,
        bottom: 0,
        top: `${UNIVERSAL_TOPBAR_HEIGHT}px`,
        position: 'absolute',
    }),
};
const copyQueryString = (source, destination) => addParamsToUrl(destination, extractParams(source), true);
export const UniversalNav = ({ renderNotifications: renderNotificationsProp = () => null, skipLinkHref = skipLinkHrefDefault, includeSidebar = false, }) => {
    var _a;
    const { canTopbarFitBackToAppButton, currentAccountId, currentUrl, isSearchFullWidth, isSidebarOpenedByTopbar, setIsSidebarOpenedByTopbar, shouldRenderSearch, shouldRenderSidebar, topbarSize, } = useUniversalNavContext();
    const { data: sessionData, isLoading: isSessionDataLoading } = useQuerySession();
    const isLoggedIn = (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.isLoggedIn) !== null && _a !== void 0 ? _a : false;
    const loginHref = copyQueryString(currentUrl, loginPath);
    const signupHref = copyQueryString(currentUrl, signupPath);
    const renderAccountMenu = findAccountsMenuRenderer({
        canTopbarFitBackToAppButton,
        currentAccountId,
        currentUrl,
        isLoadingLoggedIn: isSessionDataLoading,
        isLoggedIn,
        loginHref,
        signupHref,
    });
    const renderNotifications = findNotificationsRenderer({
        currentUrl,
        isLoggedIn,
        renderNotifications: renderNotificationsProp,
    });
    const renderSearchForm = shouldRenderSearch ? undefined : () => undefined;
    const closeSidebar = () => {
        setIsSidebarOpenedByTopbar(false);
    };
    const closeSidebarOnTriggerClick = (e) => {
        var _a, _b;
        const target = e.target;
        const triggerIsCreateMenuButton = (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains('sidebar-create-menu-button');
        const triggerIsMoreButton = (_b = target.classList) === null || _b === void 0 ? void 0 : _b.contains('MoreButton');
        const trigger = target.closest('a, button, label, [role="button"]');
        if (isSidebarOpenedByTopbar &&
            !!trigger &&
            !triggerIsCreateMenuButton &&
            !triggerIsMoreButton) {
            closeSidebar();
        }
    };
    return (jsx("div", { css: Styles.root, "data-zds": true },
        jsx(InAppTopbar, { isSearchFullWidth: isSearchFullWidth, onClick: closeSidebarOnTriggerClick, onClickOutside: closeSidebar, renderAccountMenu: renderAccountMenu, renderNotifications: renderNotifications, renderSearchForm: renderSearchForm, selectedHref: currentUrl, size: topbarSize, skipLinkHref: skipLinkHref }),
        includeSidebar && shouldRenderSidebar && (jsx("div", { css: Styles.legacySidebar },
            jsx(InAppSidebar, { currentAccountId: currentAccountId, selectedHref: currentUrl })))));
};
//# sourceMappingURL=UniversalNav.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
